<template>
    <div class="sustainable-component wage-evaluate-factors">

        <!--<div class="bg-success mb-3 p-3 rounded">vue component wage-evaluate-factors</div>-->

        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-12">
                    <a href="javascript:void(0)" @click="printBaseFactors">Visa översikt över värderingsfaktorer</a>
                </div>
            </div>
            <div class="row mt-5">
                <div class="col-12 col-md-6">

                    <table class="table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                        <thead>
                            <tr>
                                <th class="col-5">Faktornummer</th>
                                <th class="col-5">Faktornamn</th>
                                <th class="col-2"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in baseFactors" :key="index">
                                <td class="col-6">
                                    <span v-if="selected != item">{{item.FactorNr}}</span>
                                </td>
                                <td class="col-5">
                                    <span v-if="selected != item">{{item.Name}}</span>
                                </td>
                                <td class="col-1">
                                    <div class="pull-right" style="" v-if="disabled == false">
                                        <div class="dropdown text-right pr-2">
                                            <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                ...
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-right">
                                                <a href="javascript:void(0)" class="dropdown-item" @click="updateFactor(item)">Ändra</a>
                                                <a href="javascript:void(0)" class="dropdown-item" @click="deleteBaseFactor(item.BaseFactorId)">Ta bort</a>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                </div>
                <div class="col-12 col-md-6">

                    <table class="table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                        <thead>
                            <tr>
                                <th class="col-3">Gradnummer</th>
                                <th class="col-3">Beskrivning</th>
                                <th class="col-3">Poäng</th>
                                <th class="col-3"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in factorGrades" :key="index">
                                <td class="col-6">
                                    <span v-if="selected != item">{{item.GradeNumber}}</span>
                                </td>
                                <td class="col-5">
                                    <span v-if="selected != item">{{item.Description}}</span>
                                </td>
                                <td class="col-5">
                                    <span v-if="selected != item">{{item.Points}}</span>
                                </td>
                                <td class="col-1">
                                    <div class="pull-right" style="" v-if="disabled == false">
                                        <div class="dropdown text-right pr-2">
                                            <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                                ...
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-right">
                                                <a href="javascript:void(0)" class="dropdown-item" @click="updateGrade(item)">Ändra</a>
                                                <a href="javascript:void(0)" class="dropdown-item" @click="deleteFactorGrade(item.GradeNumber)">Ta bort</a>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="row">
                <div class="col col-md-6">

                    <div class="container-fluid p-0">
                        <div class="row">
                            <div class="col">
                                <p>
                                    Vill du <strong>ta bort</strong> en eller flera faktorer kan du göra detta genom att klicka på Radera i tabellen ovan.
                                </p>
                                <p>
                                    Vill du <strong>ändra</strong> klickar du på Ändra och skriver in  ändringen.
                                </p>
                                <p>
                                    Vill du <strong>lägga till</strong> faktor gör du detta genom att skriva in Faktornummer, Faktornamn, Gradnummer och Poäng i nedanstående tabell.
                                </p>
                            </div>

                        </div>
                        <v-form v-model="valid" ref="form">
                            <div class="row">
                                <div class="col">
                                    <v-text-field v-bind:disabled="disabled" bg-color="white" label="Faktornummer" :rules="[rules.positiveInteger]" v-model="factorNumber" variant="outlined"></v-text-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <v-text-field v-bind:disabled="disabled" bg-color="white" label="Faktornamn" :rules="[rules.required]" v-model="factorName" variant="outlined"></v-text-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="addBaseFactor">
                                        Spara faktor
                                    </v-btn>
                                </div>
                            </div>
                        </v-form>
                    </div>

                </div>
                <div class="col col-md-6">
                    <v-form v-model="valid" ref="form2">
                        <div class="container-fluid p-0">
                            <div>
                                <v-select bg-color="white" variant="outlined" :rules="[rules.required]" label="Värderingsfaktor" :items="baseFactors" v-model="selectedFactor" item-title="Name" item-value="BaseFactorId"></v-select>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <v-text-field v-bind:disabled="disabled" bg-color="white" label="Gradnummer" :rules="[rules.positiveInteger]" v-model="gradeNumber" variant="outlined"></v-text-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <v-text-field v-bind:disabled="disabled" bg-color="white" label="Beskrivning" :rules="[rules.required]" v-model="description" variant="outlined"></v-text-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <v-text-field v-bind:disabled="disabled" bg-color="white" label="Poäng" :rules="[rules.requiredNumberWithZero]" v-model="points" variant="outlined"></v-text-field>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="addBaseFactorGrade">
                                        Skapa grad
                                    </v-btn>
                                </div>
                            </div>
                        </div>
                    </v-form>
                </div>
            </div>
        </div>

        <WageUpdateBaseFactor ref="updateBaseFactor" @updated="load"></WageUpdateBaseFactor>
        <WageUpdateBaseGrade ref="updateBaseGrade" @updated="load"></WageUpdateBaseGrade>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    import WageService from "../../Services/WageService";
    import ValidationService from "../../Services/ValidationService";
    import { getCurrentInstance } from 'vue'
    import WageUpdateBaseFactor from "./update/update-base-factor.vue"
    import WageUpdateBaseGrade from "./update/update-base-grade.vue"
    import CommonSpinner from '../../common/common-spinner.vue'
    import { ref } from 'vue'

    const updateBaseFactor = ref(null);
    const updateBaseGrade = ref(null);
    const form = ref(null);
    const form2 = ref(null);

    export default {
        emits: ['updated'],
        name: 'wage-evaluate-factors',
        components: {
            WageUpdateBaseFactor,
            WageUpdateBaseGrade,
            CommonSpinner
        },
        props: {
            model: Object,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            updateFactor(item) {
                this.loading++;
                this.updateBaseFactor.open(item);
                this.loading--;
            },
            updateGrade(item) {
                this.loading++;
                this.updateBaseGrade.open(item);
                this.loading--;
            },
            async load() {
                this.loading++;
                try {
                    await this.loadFactors();
                    if (this.baseFactors.length > 0 && this.selectedFactor == null)
                        this.selectedFactor = this.baseFactors[0].BaseFactorId;
                    await this.loadGrades(this.selectedFactor);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadFactors() {
                this.loading++;
                try {
                    this.baseFactors = await WageService.getBaseFactors();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async printBaseFactors() {
                this.newWindow = window.open('/wagesettingsprint/PrintBaseFactors', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
            },
            async deleteBaseFactor(baseFactorId) {
                if (confirm(" Är du säker att du vill radera faktorn?")) {
                    this.loading++;
                    try {
                        await WageService.deleteBaseFactor(baseFactorId);
                        this.displaySnackBar("Borttaget");
                        this.load();
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            async addBaseFactor() {
                var result = await this.form.validate();
                if (result.valid != true)
                    return;
                this.loading++;
                try {
                    await WageService.addBaseFactor(this.factorNumber, this.factorName)
                    this.displaySnackBar("Sparat");
                    this.load();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async addBaseFactorGrade() {
                var result = await this.form2.validate();
                if (result.valid != true)
                    return;
                this.loading++;
                try {
                    await WageService.addBaseFactorGrade(this.selectedFactor, this.gradeNumber, this.description, this.points);
                    await this.loadGrades(this.selectedFactor);
                    this.displaySnackBar("Sparat");
                   
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat, kontrollera gradnummer")
                }
                this.loading--;
            },
            async deleteFactorGrade(gradeNumber) {
                if (confirm("Är du säker att du vill radera graden?")) {
                    this.loading++;
                    try {
                        await WageService.deleteBaseFactorGrade(this.selectedFactor, gradeNumber);
                        await this.loadGrades(this.selectedFactor);
                        this.displaySnackBar("Borttaget");
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            async loadGrades(baseFactorId) {
                this.loading++;
                try {
                    var response = await WageService.getWageFactorGrades(baseFactorId);
                    this.factorGrades = response;
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
                points: null,
                valid: false,
                rules: ValidationService.rules(),
                baseFactors: [],
                selectedFactor: null,
                gradeNumber: null,
                factorNumber: null,
                factorName: "",
                description: "",
                factorGrades: [],
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            selectedFactor: function (newVal) {
                this.loadGrades(newVal);
            },
        },
        mounted() {
            this.internalModel = this.model;
            this.load();
        },

        // eslint-disable-next-line
        setup(props, { emit }) {
            return { updateBaseFactor, updateBaseGrade, form, form2 }
        }

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    

</style>
